export default "__VITE_ASSET__N32R0aNW__"